import React from 'react';
import ShortTests from '../shorts/Tests';
import ShortNews from '../shorts/News';
import { Helmet } from 'react-helmet-async';
import AdSlot from '../ads/AdSlot';

const Imprint = () => {
    const pageTitle = 'Impressum | NGCTV';
    const pageDescription = 'Impressum von NGCTV – Betreiberinformationen, Kontakt und rechtliche Hinweise.';

    return (
        <>
            {/* SEO / Head */}
            <Helmet>
                <title>{pageTitle}</title>
                <meta name="description" content={pageDescription} />
                <meta property="og:title" content={pageTitle} />
                <meta property="og:description" content={pageDescription} />
                <meta property="og:type" content="website" />
                <link rel="canonical" href={`https://ngctv.de/impressum`} />
            </Helmet>

            <main>
                <div className='wrapper'>
                    <div className='rows'>
                        <div className='row'>
                            <div className='category'>Impressum</div>
                            <div className="impressum">

                                ngctv.de und weitere Länderdomains und Sub-Domains gehören <span className="black"><b>NGC</b></span><span className="red"><b>TV</b></span>.<br />
                                Betreiber der Website ngctv.de<br /><br />
                                Ralf Glende<br />
                                Erlenweg 13<br />
                                41372 Niederküchten<br /><br />

                                <h3>Kontakt</h3>
                                <span className="black"><b>NGC</b></span><span className="red"><b>TV</b></span>-Nutzer: Bei Fragen oder Problemen rund um <span className="black"><b>NGC</b></span><span className="red"><b>TV</b></span><br />
                                schreibe eine E-Mail an info@ngctv.de oder gehe auf Kontakt.<br /><br />

                                Marketing: Bei Anfragen zu Marketingkooperationen wendet euch bitte an info@ngctv.de .<br />
                                Die Kontaktdaten für die Buchung von Werbeflächen findet ihr weiter unten unter „Werbung".<br /><br />

                                Sonstiges: Alle weiteren Anfragen bitte an info@ngctv.de .<br /><br />

                                <h3>Werbung</h3>
                                Die Buchung von individuellen Werbeformen, wie z.B. Banner, erfolgt über<br />
                                Kontakt. Bitte richtet eure Anfragen an die o.g. Postadresse oder per E-Mail an<br />
                                info@ngctv.de<br /><br />

                                <h3>Rechtliche Hinweise</h3>
                                <span className="black"><b>NGC</b></span><span className="red"><b>TV</b></span> behält sich alle Rechte an den eigenen Texten, eigenen Bildern, eigenen Grafiken<br />
                                sowie an dem gesamten Design inklusive Layout-, Schrift- und Farbgestaltung der Website vor.<br />
                                Die Vervielfältigung und Verwendung dieser Informationen und/oder Daten sowie jegliche Art<br />
                                von Kopie oder Reproduktion bedarf der vorherigen schriftlichen Zustimmung von <span className="black"><b>NGC</b></span><span className="red"><b>TV</b></span>.<br />
                                Zuwiderhandlungen werden rechtlich verfolgt.<br /><br />

                                <h3>Haftungsausschluss</h3>
                                <span className="black"><b>NGC</b></span><span className="red"><b>TV</b></span> haftet nicht für den Inhalt der Veröffentlichungen der Nutzer; dies gilt<br />
                                insbesondere für Fälle, in denen die von Nutzern eingestellten Inhalte gegen das geistige<br />
                                Eigentum (Markenrechte, Urheberrechte, etc.) oder gegen das Persönlichkeitsrecht Dritter verstoßen.<br />
                                Dieser Haftungsausschluss gilt gleichermaßen für Inhalte von Internetseiten, welche von den Nutzern<br />
                                ohne Kenntnis von <span className="black"><b>NGC</b></span><span className="red"><b>TV</b></span> verlinkt wurden. <span className="black"><b>NGC</b></span><span className="red"><b>TV</b></span> übernimmt daher keine Gewähr für<br />
                                die Aktualität, Richtigkeit, Vollständigkeit oder Qualität der dort bereitgestellten Informationen<br />
                                und distanziert sich hiermit ausdrücklich von diesen Inhalten. Auch ist <span className="black"><b>NGC</b></span><span className="red"><b>TV</b></span> eine andauernde<br />
                                inhaltliche Kontrolle der von Nutzern eingestellten Inhalte sowie der verlinkten fremden Seiten nicht möglich<br />
                                und ohne konkrete Anhaltspunkte einer Rechtsverletzung auch nicht zumutbar.<br /><br />

                                <h3>Copyright</h3>
                                Sämtlicher Inhalt, Spieltitel, Handelsnamen beziehungsweise Aufmachungen, Warenzeichen, Illustrationen und damit verbundene Bilder sind Warenzeichen beziehungsweise urheberrechtlich geschützte Werke ihrer jeweiligen Besitzer. Alle Rechte vorbehalten.

                            </div>
                        </div>
                        <div className='row'>
                            <ShortTests />
                            <ShortNews />
                            <AdSlot slot="2119524913" />
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default Imprint;
